(function($){
  $(document).ready(function() {

    const stickymenu = $("body:not(.admin) #site-header");
    const mystickymenu = stickymenu.stickybits({
        useStickyClasses: true,
        // stickyBitStickyOffset: 0
    });
    window.addEventListener("resize", () => {
        mystickymenu.update();
    });

    const menu = $('#menu'),
        // menuSecondaryHeader = $('.secondary-header').clone(),
        // menuLegal    = $('.legal-footer').clone(),
        recherche    = $('#recherche'),
        formchercher = $('#formchercher');

        // recherche.appendTo($('.primary-header'));
    /*
    * Responsive JS
    * http://www.javascriptkit.com/javatutors/matchmediamultiple.shtml
    */
    const bp = [0, 480, 768, 1024, 1240],
        mq_to_xs =    `(max-width: ${bp[1] - 1}px)`,                             // 0->479
        mq_xs_to_sm = `(max-width: ${bp[2] - 1}px) and (min-width: ${bp[1]}px)`, // 480->767
        mq_sm_to_md = `(max-width: ${bp[3] - 1}px) and (min-width: ${bp[2]}px)`, // 768->1023
        mq_md_to_lg = `(max-width: ${bp[4] - 1}px) and (min-width: ${bp[3]}px)`, // 1024->1239
        mq_from_lg =  `(min-width: ${bp[4]}px)`,                                 // 1240->++
        mqlist = [
            window.matchMedia(mq_to_xs),
            window.matchMedia(mq_xs_to_sm),
            window.matchMedia(mq_sm_to_md),
            window.matchMedia(mq_md_to_lg),
            window.matchMedia(mq_from_lg),
        ];

    const body = $('body:not(.admin)');

    function navTactile(){
        formchercher.appendTo(recherche);
        // menuSecondaryHeader.appendTo(menu);
        recherche.appendTo(menu);
        // menuLegal.appendTo(menu);
        body.off('mouseout', '.primary-header .niv1 .menu_item');
        body.off('mouseover', '.primary-header .niv1 > .has_submenu');
    }

    function navSouris(){
        formchercher.appendTo($('#site-header'));
        // menuLegal.remove();
        // menuSecondaryHeader.remove();

        body.on('mouseout', '.primary-header .niv1 .menu_item', function(){
            $('.masque').click();
        });
        body.on('mouseover', '.primary-header .niv1 > .has_submenu', function(){
            $('.masque').show();
        });
    }

    function mediaqueryresponse(mql){
        if (mql.matches){
            if (mq_to_xs == mql.media){
                navTactile();
            }
            if (mq_xs_to_sm == mql.media){
                navTactile();
            }
            if (mq_sm_to_md == mql.media){
                navTactile();
            }
            if (mq_md_to_lg == mql.media){
                navSouris();
            }
            if (mq_from_lg == mql.media){
                navSouris();
            }
        }
    }

    for (var i=0; i<mqlist.length; i++){
        mediaqueryresponse(mqlist[i]);
        mqlist[i].addListener(mediaqueryresponse);
    }

  })
})(jQuery);
